import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const CommentIcon = createIcon(
  'Comment',
  <path d="M20,2 L4,2 C2.9,2 2,2.9 2,4 L2,16 C2,17.1 2.9,18 4,18 L18,18 L22,22 L22,4 C22,2.9 21.1,2 20,2 Z M17,14 L7,14 C6.45,14 6,13.55 6,13 C6,12.45 6.45,12 7,12 L17,12 C17.55,12 18,12.45 18,13 C18,13.55 17.55,14 17,14 Z M17,11 L7,11 C6.45,11 6,10.55 6,10 C6,9.45 6.45,9 7,9 L17,9 C17.55,9 18,9.45 18,10 C18,10.55 17.55,11 17,11 Z M17,8 L7,8 C6.45,8 6,7.55 6,7 C6,6.45 6.45,6 7,6 L17,6 C17.55,6 18,6.45 18,7 C18,7.55 17.55,8 17,8 Z" />
);

export default CommentIcon;
